/* PhotoJewels app-like theme JS */
(function () {
  'use strict';

  /* ---------- Cart count sync ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-visible', count > 0);
    });
    document.querySelectorAll('[data-cart-dot]').forEach(function (el) {
      el.classList.toggle('is-visible', count > 0);
    });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', refreshCart);

  /* ---------- Photo upload preview (the stone) ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-photo-input]');
    if (!input || !input.files || !input.files[0]) return;

    var wrap = input.closest('[data-photo-section]');
    if (!wrap) return;
    var file = input.files[0];

    if (file.size > 20 * 1024 * 1024) {
      alert('Please choose a photo under 20 MB.');
      input.value = '';
      return;
    }

    var reader = new FileReader();
    reader.onload = function (ev) {
      var lens = wrap.querySelector('[data-stone-lens]');
      if (lens) {
        lens.innerHTML = '';
        var img = document.createElement('img');
        img.src = ev.target.result;
        img.alt = 'Your photo preview';
        lens.appendChild(img);
        var glare = document.createElement('div');
        glare.className = 'pj-stone__glare';
        lens.appendChild(glare);
      }
      wrap.classList.add('has-photo');
      var stone = wrap.querySelector('.pj-stone');
      if (stone) stone.classList.add('has-photo');
      var label = wrap.querySelector('[data-upload-label]');
      if (label) label.textContent = label.dataset.changeText || 'Change photo';

      // mark step done
      var stepEl = document.querySelector('[data-step="photo"]');
      if (stepEl) stepEl.classList.add('is-done');

      // enable ATC if it was gated
      var form = input.form;
      if (form) {
        var atc = form.querySelector('[data-atc]');
        if (atc && atc.dataset.requiresPhoto === 'true') {
          atc.disabled = false;
          atc.textContent = atc.dataset.readyText || atc.textContent;
        }
      }
    };
    reader.readAsDataURL(file);
  });

  /* ---------- Product form: AJAX add to cart (multipart keeps the file) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var photoInput = form.querySelector('[data-photo-input]');
    var requires = form.querySelector('[data-atc]') && form.querySelector('[data-atc]').dataset.requiresPhoto === 'true';
    if (requires && photoInput && (!photoInput.files || !photoInput.files.length)) {
      var photoSection = document.querySelector('[data-photo-section]');
      if (photoSection) photoSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var btn = form.querySelector('[data-atc]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.dataset.addingText || 'Adding…'; }

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to bag'); });
        return r.json();
      })
      .then(function () {
        refreshCart();
        window.location.href = form.dataset.cartUrl || '/cart';
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        alert(err.message);
      });
  });

  /* ---------- Variant / finish picker ---------- */
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-option-input]');
    if (!radio) return;
    var form = document.querySelector('[data-product-form]');
    var wrap = radio.closest('[data-variant-picker]');
    if (!form || !wrap) return;

    var variants = [];
    try { variants = JSON.parse(wrap.querySelector('[data-variants-json]').textContent); } catch (err) { return; }

    var selected = [];
    wrap.querySelectorAll('[data-option-index]').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      if (checked) selected[parseInt(group.dataset.optionIndex, 10)] = checked.value;
    });

    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });

    var idInput = form.querySelector('[name="id"]');
    var atc = form.querySelector('[data-atc]');
    if (match) {
      idInput.value = match.id;
      form.dataset.priceCents = match.price;
      // price
      var priceEl = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare-price]');
      var saveEl = document.querySelector('[data-save]');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
          if (saveEl) { saveEl.textContent = saveEl.dataset.saveText.replace('{amount}', formatMoney(match.compare_at_price - match.price)); saveEl.style.display = ''; }
        } else {
          compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }
      // image
      if (match.featured_image && match.featured_image.src) {
        var mainImg = document.querySelector('[data-main-image]');
        if (mainImg) mainImg.src = match.featured_image.src;
      }
      // availability
      if (atc) {
        if (match.available) {
          if (!(atc.dataset.requiresPhoto === 'true' && !document.querySelector('[data-photo-section].has-photo'))) atc.disabled = false;
          atc.textContent = atc.dataset.readyText || atc.textContent;
        } else {
          atc.disabled = true;
          atc.textContent = atc.dataset.soldoutText || 'Sold out';
        }
      }
      // selected value label
      var valueLabel = radio.closest('[data-option-index]') && radio.closest('[data-option-index]').querySelector('[data-selected-value]');
      if (valueLabel) valueLabel.textContent = radio.value;
      // step done
      var stepEl = document.querySelector('[data-step="style"]');
      if (stepEl) stepEl.classList.add('is-done');
      // finish filter on image (visual nicety)
      var filters = { 'silver': 'saturate(.35) brightness(1.08)', 'rose gold': 'sepia(.35) hue-rotate(-12deg) saturate(1.15)' };
      var mainImg2 = document.querySelector('[data-main-image]');
      if (mainImg2 && !match.featured_image) {
        var f = filters[radio.value.toLowerCase()] || 'none';
        mainImg2.style.filter = f;
      }
    } else if (atc) {
      atc.disabled = true;
      atc.textContent = atc.dataset.unavailableText || 'Unavailable';
    }
  });

  var moneyFormat = window.PJ_MONEY_FORMAT || '\u20B9{{amount}}';
  function formatMoney(cents) {
    var amount = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* ---------- Tabs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tab]');
    if (!btn) return;
    var tabs = btn.closest('[data-tabs]');
    if (!tabs) return;
    tabs.querySelectorAll('[data-tab]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    var scope = tabs.parentElement;
    scope.querySelectorAll('[data-tabpanel]').forEach(function (p) {
      p.classList.toggle('is-active', p.dataset.tabpanel === btn.dataset.tab);
    });
  });

  /* ---------- PDP thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var main = document.querySelector('[data-main-image]');
    if (main) { main.src = t.dataset.src; main.style.filter = 'none'; }
    document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
  });

  /* ---------- Cart quantity ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var row = btn.closest('[data-line]');
    var input = row.querySelector('[data-qty-input]');
    var qty = Math.max(0, parseInt(input.value || '1', 10) + parseInt(btn.dataset.qtyChange, 10));
    changeLine(row.dataset.line, qty);
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove-line]');
    if (!rm) return;
    e.preventDefault();
    changeLine(rm.closest('[data-line]').dataset.line, 0);
  });
  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    }).then(function () { window.location.reload(); });
  }

  /* ---------- Video strip: tap = play/pause, expand = fullscreen overlay ---------- */
  function ensureInlineVideo(card) {
    var media = card.querySelector('.pj-video__media');
    var vid = media.querySelector('video');
    if (vid) return vid;
    vid = document.createElement('video');
    vid.src = card.dataset.videoUrl;
    vid.playsInline = true;
    vid.setAttribute('playsinline', '');
    vid.loop = true;
    vid.style.cssText = 'width:100%;height:100%;object-fit:cover;position:absolute;inset:0;';
    media.insertBefore(vid, media.firstChild);
    var poster = media.querySelector('img');
    if (poster) poster.style.display = 'none';
    vid.addEventListener('play', function () { card.classList.add('is-playing'); });
    vid.addEventListener('pause', function () { card.classList.remove('is-playing'); });
    return vid;
  }

  function openVideoLightbox(url) {
    // pause all inline videos
    document.querySelectorAll('[data-video] video').forEach(function (v) { v.pause(); });
    var box = document.createElement('div');
    box.className = 'pj-videolightbox';
    box.innerHTML =
      '<button type="button" class="pj-videolightbox__close" aria-label="Close">&#10005;</button>' +
      '<video src="' + url + '" playsinline autoplay controls controlsList="nodownload noplaybackrate" disablepictureinpicture oncontextmenu="return false"></video>';
    document.body.appendChild(box);
    document.body.style.overflow = 'hidden';
    function close() {
      var v = box.querySelector('video');
      if (v) v.pause();
      box.remove();
      document.body.style.overflow = '';
    }
    box.addEventListener('click', function (ev) {
      if (ev.target === box || ev.target.closest('.pj-videolightbox__close')) close();
    });
    document.addEventListener('keydown', function esc(ev) {
      if (ev.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
    });
  }

  window.PJVideoLightbox = openVideoLightbox;

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-video]');
    if (!card || !card.dataset.videoUrl) return;

    if (e.target.closest('[data-video-expand]')) {
      e.preventDefault();
      openVideoLightbox(card.dataset.videoUrl);
      return;
    }

    var vid = ensureInlineVideo(card);
    if (vid.paused) {
      // pause other cards first
      document.querySelectorAll('[data-video] video').forEach(function (v) { if (v !== vid) v.pause(); });
      vid.play();
    } else {
      vid.pause();
    }
  });
})();

/* ---------- PDP step wizard ---------- */
(function () {
  'use strict';

  var flow = null;

  function getFlow() {
    if (!flow) flow = document.querySelector('[data-flow]');
    return flow;
  }

  function goToStep(n) {
    var f = getFlow();
    if (!f) return;
    f.dataset.currentStep = n;
    document.body.classList.toggle('pj-focus', parseInt(n, 10) >= 2);
    window.scrollTo(0, 0);

    // panels
    f.querySelectorAll('[data-step-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.dataset.stepPanel === String(n));
    });
    // action buttons
    f.querySelectorAll('[data-for-step]').forEach(function (b) {
      b.style.display = (b.dataset.forStep === String(n)) ? '' : 'none';
    });
    // progress bars: step i is done if i <= n
    f.querySelectorAll('.pj-steps [data-step]').forEach(function (s) {
      s.classList.toggle('is-done', parseInt(s.dataset.step, 10) <= n);
    });
    // title
    var title = f.querySelector('[data-flow-title]');
    if (title) title.textContent = title.dataset['title' + n] || title.getAttribute('data-title-' + n) || '';
    // back button: on step 1, go back in history; otherwise previous step
    var back = f.querySelector('[data-flow-back]');
    if (back) back.dataset.mode = n > 1 ? 'step' : 'history';

    // sync review card on entering step 3
    if (n === 3) syncReview();

    if (!goToStep._init) window.scrollTo({ top: 0, behavior: 'smooth' });
    goToStep._init = false;
  }

  function currentStep() {
    var f = getFlow();
    return f ? parseInt(f.dataset.currentStep || '1', 10) : 1;
  }

  function syncReview() {
    var f = getFlow();
    if (!f) return;
    var price = document.querySelector('[data-price]');
    var compare = document.querySelector('[data-compare-price]');
    var mainImg = document.querySelector('[data-main-image]');
    var variantLabel = document.querySelector('[data-selected-value]');

    var rp = f.querySelector('[data-review-price]');
    var rp2 = f.querySelector('[data-review-price2]');
    var rt = f.querySelector('[data-review-total]');
    var rc = f.querySelector('[data-review-compare]');
    var ri = f.querySelector('[data-review-image]');
    var rv = f.querySelector('[data-review-variant]');
    var rphoto = f.querySelector('[data-review-photo]');

    if (price) {
      if (rp) rp.textContent = price.textContent;
      if (rp2) rp2.textContent = price.textContent;
      if (rt) rt.textContent = price.textContent;
    }
    if (compare && rc) {
      rc.textContent = compare.textContent;
      rc.style.display = compare.style.display;
    }
    if (mainImg && ri) { ri.src = mainImg.src; ri.style.filter = mainImg.style.filter || 'none'; }
    if (variantLabel && rv) rv.textContent = variantLabel.textContent;

    var lensImg = f.querySelector('[data-stone-lens] img');
    if (lensImg && rphoto) { rphoto.src = lensImg.src; rphoto.style.display = ''; }
  }

  function stepList() {
    var f = getFlow();
    if (!f) return [1];
    return Array.prototype.map.call(f.querySelectorAll('[data-step-panel]'), function (p) {
      return parseInt(p.dataset.stepPanel, 10);
    }).sort(function (a, b) { return a - b; });
  }

  document.addEventListener('click', function (e) {
    var next = e.target.closest('[data-flow-next]');
    if (next) {
      if (next.disabled) return;
      var steps = stepList();
      var i = steps.indexOf(currentStep());
      if (i > -1 && i < steps.length - 1) goToStep(steps[i + 1]);
      return;
    }
    var back = e.target.closest('[data-flow-back]');
    if (back) {
      var steps2 = stepList();
      var j = steps2.indexOf(currentStep());
      if (j > 0) goToStep(steps2[j - 1]);
      else if (document.referrer && document.referrer.indexOf(location.host) > -1) history.back();
      else location.href = '/';
    }
  });

  // unlock step-2 continue button when a photo is chosen
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-photo-input]');
    if (!input || !input.files || !input.files.length) return;
    var f = getFlow();
    if (!f) return;
    var btn = f.querySelector('[data-flow-next][data-for-step="2"]');
    if (btn) {
      btn.disabled = false;
      btn.innerHTML = (btn.dataset.readyText || 'Continue') + ' <span>&rarr;</span>';
    }
  });

  function initFlow() {
    flow = null;
    if (getFlow()) { goToStep._init = true; goToStep(1); }
  }
  document.addEventListener('DOMContentLoaded', initFlow);

  // Title auto-fit: never more than 2 lines; shrink font until it fits
  function fitTitle() {
    var t = document.querySelector('.pj-pdp__title');
    if (!t) return;
    t.style.removeProperty('font-size');
    var size = parseFloat(getComputedStyle(t).fontSize);
    var guard = 0;
    while (guard < 10 && size > 12) {
      var lh = parseFloat(getComputedStyle(t).lineHeight) || size * 1.2;
      if (t.scrollHeight <= lh * 2.2) break;
      size -= 1;
      t.style.setProperty('font-size', size + 'px', 'important');
      guard++;
    }
  }
  document.addEventListener('DOMContentLoaded', fitTitle);
  window.addEventListener('load', fitTitle);
  window.addEventListener('resize', fitTitle);
  document.addEventListener('shopify:section:load', initFlow);
})();

/* ---------- Step 3: add-ons, payment, live total, place order ---------- */
(function () {
  'use strict';

  var moneyFormat = window.PJ_MONEY_FORMAT || '\u20B9{{amount}}';
  function fmt(cents) {
    var amount = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function recalcTotal() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var qty = parseInt((form.querySelector('[data-order-qty-input]') || {}).value || '1', 10);
    var unit = parseInt(form.dataset.priceCents || '0', 10);
    var total = unit * qty;
    var lineEl = document.querySelector('[data-review-price]');
    if (lineEl) lineEl.textContent = fmt(unit * qty);

    var rows = document.querySelector('[data-addon-rows]');
    if (rows) rows.innerHTML = '';

    document.querySelectorAll('[data-addon]:checked').forEach(function (a) {
      var p = parseInt(a.dataset.addonPrice, 10);
      total += p;
      if (rows) {
        var div = document.createElement('div');
        div.className = 'pj-cart__row';
        div.innerHTML = '<span></span><span></span>';
        div.children[0].textContent = a.dataset.addonLabel;
        div.children[1].textContent = fmt(p);
        rows.appendChild(div);
      }
    });

    var totalEl = document.querySelector('[data-review-total]');
    if (totalEl) totalEl.textContent = fmt(total);
    document.querySelectorAll('[data-total-inline]').forEach(function (el) { el.textContent = fmt(total); });
    window.__pjTotalCents = total;
    try { window.dispatchEvent(new CustomEvent('pj:total', { detail: { cents: total } })); } catch (e) {}
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-addon]') || e.target.closest('[data-option-input]')) recalcTotal();
  });

  // recalc when entering step 3 (flow JS calls syncReview; also hook here)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-flow-next]')) setTimeout(recalcTotal, 0);
  });

  /* Place order: add main item (with photo) → add add-ons → save payment preference → checkout */
  /* Order quantity stepper (step 3) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-order-qty-change]');
    if (!b) return;
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var hidden = form.querySelector('[data-order-qty-input]');
    var disp = document.querySelector('[data-order-qty-display]');
    var q = Math.min(10, Math.max(1, parseInt(hidden.value || '1', 10) + parseInt(b.dataset.orderQtyChange, 10)));
    hidden.value = q;
    if (disp) disp.value = q;
    recalcTotal();
  });

  /* Add & continue shopping (step 3) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-continue]');
    if (!btn || btn.disabled) return;
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = btn.dataset.addingText || 'Adding\u2026';
    var addons = Array.prototype.map.call(document.querySelectorAll('[data-addon]:checked'), function (a) {
      return { id: parseInt(a.value, 10), quantity: 1 };
    });
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add item'); });
        return r.json();
      })
      .then(function () {
        // fire add-ons without waiting (keepalive survives navigation), redirect immediately
        if (addons.length) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: addons }),
            keepalive: true
          }).catch(function () {});
        }
        window.location.href = btn.dataset.continueUrl || '/collections';
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.innerHTML = original;
        alert(err.message);
      });
  });

  window.PJBuildCart = function () {
    var form = document.querySelector('[data-product-form]');
    if (!form) return Promise.resolve(null); // cart page: cart already built
    var addons = Array.prototype.map.call(document.querySelectorAll('[data-addon]:checked'), function (a) {
      return { id: parseInt(a.value, 10), quantity: 1 };
    });
    return fetch('/cart/clear.js', { method: 'POST' })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', body: new FormData(form) }); })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add item'); });
        return r.json();
      })
      .then(function () {
        if (!addons.length) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: addons })
        });
      });
  };

  document.addEventListener('DOMContentLoaded', recalcTotal);
})();

/* ---------- CSV reviews ---------- */
(function () {
  'use strict';

  function parseCSV(text) {
    var rows = [], row = [], cur = '', inQ = false;
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      if (inQ) {
        if (ch === '"') {
          if (text[i + 1] === '"') { cur += '"'; i++; }
          else inQ = false;
        } else cur += ch;
      } else if (ch === '"') inQ = true;
      else if (ch === ',') { row.push(cur); cur = ''; }
      else if (ch === '\n' || ch === '\r') {
        if (ch === '\r' && text[i + 1] === '\n') i++;
        row.push(cur); cur = '';
        if (row.length > 1 || row[0] !== '') rows.push(row);
        row = [];
      } else cur += ch;
    }
    if (cur !== '' || row.length) { row.push(cur); rows.push(row); }
    return rows;
  }

  function col(headers, names) {
    for (var i = 0; i < headers.length; i++) {
      var h = headers[i].toLowerCase().trim();
      if (names.indexOf(h) > -1) return i;
    }
    return -1;
  }

  function starsHTML(r) {
    var full = Math.round(Math.min(5, Math.max(0, r)));
    var s = '';
    for (var i = 0; i < 5; i++) s += i < full ? '\u2605' : '\u2606';
    return s;
  }

  function initCsvReviews() {
    var wrap = document.querySelector('[data-csv-reviews]');
    if (!wrap || wrap.dataset.loaded) return;
    wrap.dataset.loaded = '1';

    fetch(wrap.dataset.csvUrl)
      .then(function (r) { if (!r.ok) throw new Error('csv'); return r.text(); })
      .then(function (text) {
        var rows = parseCSV(text);
        if (rows.length < 2) throw new Error('empty');
        var head = rows[0];
        var iName = col(head, ['name', 'customer', 'author', 'reviewer']);
        var iRating = col(head, ['rating', 'stars', 'score']);
        var iText = col(head, ['review', 'text', 'body', 'comment', 'message']);
        var iDate = col(head, ['date', 'created_at', 'reviewed_at']);
        var iPhoto = col(head, ['photo', 'image', 'picture', 'photo_url', 'image_url']);
        var iVideo = col(head, ['video', 'video_url', 'reel']);
        var iHandle = col(head, ['product_handle', 'handle', 'product']);

        var reviews = rows.slice(1).map(function (r) {
          return {
            name: iName > -1 ? r[iName] : '',
            rating: iRating > -1 ? parseFloat(r[iRating]) || 5 : 5,
            text: iText > -1 ? r[iText] : '',
            date: iDate > -1 ? r[iDate] : '',
            photo: iPhoto > -1 ? r[iPhoto] : '',
            video: iVideo > -1 ? r[iVideo] : '',
            handle: iHandle > -1 ? (r[iHandle] || '').trim() : ''
          };
        }).filter(function (r) { return r.text || r.name; });

        // per-product filter when the column is used and matches exist
        var ph = wrap.dataset.productHandle;
        if (iHandle > -1) {
          var mine = reviews.filter(function (r) { return r.handle === ph; });
          if (mine.length) reviews = mine;
        }

        if (!reviews.length) throw new Error('none');

        // summary
        var avg = reviews.reduce(function (s, r) { return s + r.rating; }, 0) / reviews.length;
        var summary = wrap.querySelector('[data-csv-summary]');
        wrap.querySelector('[data-csv-score]').textContent = (Math.round(avg * 10) / 10).toFixed(1);
        wrap.querySelector('[data-csv-stars]').textContent = starsHTML(avg);
        wrap.querySelector('[data-csv-count]').textContent = reviews.length.toLocaleString('en-IN') + ' reviews';
        summary.style.display = '';

        var list = wrap.querySelector('[data-csv-list]');
        var more = wrap.querySelector('[data-csv-more]');
        var shown = 0, PAGE = 5;

        function isVideoUrl(u) { return /\.(mp4|webm|mov|m4v)(\?|$)/i.test(u || ''); }

        list.className = (list.className + ' pj-revgrid').trim();

        function renderMore() {
          var slice = reviews.slice(shown, shown + PAGE);
          slice.forEach(function (r) {
            var d = document.createElement('div');
            d.className = 'pj-looxcard';

            var vidUrl = r.video && r.video.indexOf('http') === 0 ? r.video
                       : (isVideoUrl(r.photo) ? r.photo : '');
            var imgUrl = !isVideoUrl(r.photo) && r.photo && r.photo.indexOf('http') === 0 ? r.photo : '';

            if (vidUrl) {
              var vwrap = document.createElement('div');
              vwrap.className = 'pj-looxcard__media pj-looxcard__media--video';
              vwrap.setAttribute('data-review-video', vidUrl);
              var v = document.createElement('video');
              v.src = vidUrl; v.muted = true; v.playsInline = true; v.preload = 'metadata';
              vwrap.appendChild(v);
              var badge = document.createElement('span');
              badge.className = 'pj-looxcard__play';
              badge.innerHTML = '&#9654;';
              vwrap.appendChild(badge);
              d.appendChild(vwrap);
            } else if (imgUrl) {
              var iwrap = document.createElement('div');
              iwrap.className = 'pj-looxcard__media';
              var img = document.createElement('img');
              img.src = imgUrl; img.loading = 'lazy'; img.alt = 'Customer photo';
              iwrap.appendChild(img);
              d.appendChild(iwrap);
            }

            var body = document.createElement('div');
            body.className = 'pj-looxcard__body';
            body.innerHTML =
              '<div class="pj-looxcard__stars"></div>' +
              '<div class="pj-looxcard__name"><span></span><em class="pj-looxcard__verified">&#10003;</em></div>' +
              '<div class="pj-looxcard__text"></div>' +
              (r.date ? '<div class="pj-looxcard__date"></div>' : '');
            body.querySelector('.pj-looxcard__stars').textContent = starsHTML(r.rating);
            body.querySelector('.pj-looxcard__name span').textContent = r.name || 'Customer';
            body.querySelector('.pj-looxcard__text').textContent = r.text;
            if (r.date) body.querySelector('.pj-looxcard__date').textContent = r.date;
            d.appendChild(body);

            list.appendChild(d);
          });
          shown += slice.length;
          more.style.display = shown < reviews.length ? '' : 'none';
        }

        wrap.querySelector('[data-csv-loading]').remove();
        renderMore();
        more.addEventListener('click', renderMore);
      })
      .catch(function () {
        var loading = wrap.querySelector('[data-csv-loading]');
        if (loading) loading.textContent = 'Reviews could not be loaded.';
      });
  }

  document.addEventListener('DOMContentLoaded', initCsvReviews);
  document.addEventListener('shopify:section:load', function () {
    var w = document.querySelector('[data-csv-reviews]');
    if (w) delete w.dataset.loaded;
    initCsvReviews();
  });
})();


  /* review video tap -> fullscreen lightbox */
  document.addEventListener('click', function (e) {
    var rv = e.target.closest('[data-review-video]');
    if (!rv) return;
    if (window.PJVideoLightbox) window.PJVideoLightbox(rv.dataset.reviewVideo);
  });

/* ---------- Cart page add-ons: toggle adds/removes instantly ---------- */
document.addEventListener('change', function (e) {
  var box = e.target.closest('[data-cart-addon]');
  if (!box) return;
  box.disabled = true;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: box.value, quantity: box.checked ? 1 : 0 })
  })
    .then(function (r) {
      if (r.ok) return r.json();
      if (box.checked) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(box.value, 10), quantity: 1 }] })
        });
      }
    })
    .then(function () { window.location.reload(); })
    .catch(function () { box.disabled = false; box.checked = !box.checked; });
});

/* ---------- Celebs: see more ---------- */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-celebs-more]');
  if (!btn) return;
  document.querySelectorAll('.pj-celebcard--extra').forEach(function (c) { c.classList.remove('pj-celebcard--extra'); });
  btn.remove();
});

/* ============ burger menu drawer ============ */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-menu-open]');
    var close = e.target.closest('[data-menu-close]');
    var drawer = document.querySelector('[data-menu-drawer]');
    if (!drawer) return;
    if (open) {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      open.setAttribute('aria-expanded', 'true');
    } else if (close) {
      drawer.hidden = true;
      document.body.style.overflow = '';
      var b = document.querySelector('[data-menu-open]');
      if (b) b.setAttribute('aria-expanded', 'false');
    } else if (!drawer.hidden && e.target.closest('[data-menu-drawer] a')) {
      drawer.hidden = true;
      document.body.style.overflow = '';
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var drawer = document.querySelector('[data-menu-drawer]');
    if (drawer && !drawer.hidden) { drawer.hidden = true; document.body.style.overflow = ''; }
  });
})();
